import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

// Services
import { ContainerService } from '../../services/container.service';
import { ModalLockComponent } from '../../controls/modal-lock/modal-lock.component';
import { CommonExpenseGuardService } from '../../services/common-expense-guard.service';

@Component({
  selector: 'app-layout-dashboard',
  templateUrl: './layout-dashboard.component.html',
  styleUrls: ['./layout-dashboard.component.sass']
})
export class LayoutDashboardComponent implements OnInit {
  @ViewChild(ModalLockComponent) modalLock: ModalLockComponent;

  // variables
  public subscriptionContainer: Subscription;
  public containerLg = false;
  public containerMd = false;
  public activateOverlay = 'none';
  public modalRef: BsModalRef;

  constructor(
    private _containerService: ContainerService,
    private modalService: BsModalService,
    private _commonExpenseGuardService: CommonExpenseGuardService,
  ) {
  }

  ngOnInit() {
    this._commonExpenseGuardService.setModalControl(this.modalLock);
    // oyente
    // this.subscriptionContainer = this._containerService.observableStateContainer$
    //   .subscribe(
    //     res => {
    //       if (res === 'large') {
    //         this.containerLg = !this.containerLg;
    //         this.containerMd = false;
    //         this.activateOverlay = 'block';
    //       }
    //       if (res === 'medium') {
    //         this.containerLg = !this.containerLg;
    //         this.containerMd = true;
    //         this.activateOverlay = 'block';
    //       }
    //     });
  }

  // cerramos container
  public closeContainer(): void {
    this.activateOverlay = 'none';
    this.containerLg = false;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/layout-dashboard/layout-dashboard.component.ts